export default __webpack_public_path__ + "static/media/Truck.8fd7cbc8.png";